var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _rect3, _rect4, _rect5, _rect6, _path7, _path8, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInHomeCareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.0955,
    y: 0.864014,
    width: 2.7619,
    height: 5.52381,
    fill: "#BBDEFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.53571L31.0179 8.88131V31.0178H16V2.53571Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.982178 8.88086L16 2.53571V31.0178H0.982178V8.88086Z",
    fill: "#F1F8FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 31.5893,
    width: 33.1429,
    height: 1.55357,
    rx: 0.776786,
    fill: "#DBEDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6793 10.7153C32.4677 11.1831 31.9196 11.3696 31.4683 11.1274L16.1413 2.90085C15.9658 2.80665 15.8967 2.58346 15.9883 2.40647C16.3891 1.63175 17.3248 1.34522 18.0904 1.76273L32.2722 9.49612C32.7013 9.73014 32.8813 10.2689 32.6793 10.7153Z",
    fill: "#DBEDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.566062 10.2263C0.310758 9.7332 0.508674 9.11153 1.00254 8.85525L15.5234 1.31994C16.1551 0.992155 16.898 1.01166 17.4977 1.37178L18.6322 2.05308L1.839 10.6332C1.36959 10.873 0.807991 10.6935 0.566062 10.2263Z",
    fill: "#B5DCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6786 20.2606C19.6786 19.9392 19.9392 19.6786 20.2606 19.6786H27.9001C28.2216 19.6786 28.4822 19.9392 28.4822 20.2606V31.5893H19.6786V20.2606Z",
    fill: "#5085C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6608 20.6607H26.3572V31.0178H20.6608V20.6607Z",
    fill: "#BBDEFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.66077,
    y: 19.6786,
    width: 4.14286,
    height: 4.14286,
    fill: "#BBDEFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.32141,
    y: 19.6786,
    width: 4.14286,
    height: 4.14286,
    fill: "#BBDEFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.32141,
    y: 24.3393,
    width: 4.14286,
    height: 4.14286,
    fill: "#BBDEFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.66077,
    y: 24.3393,
    width: 4.14286,
    height: 4.14286,
    fill: "#BBDEFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 16.0536L20.0861 12.5108C20.9271 11.6631 20.9203 10.2639 20.0861 9.4368C19.2314 8.58903 17.8946 8.59593 17.0364 9.4368L16.5714 9.89171L16.1065 9.4368C15.2483 8.59593 13.9115 8.58903 13.0568 9.4368C12.2226 10.2639 12.2158 11.6631 13.0568 12.5108L16.5714 16.0536Z",
    fill: "#D0262E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_649_548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 9,
    height: 9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 16.0536L20.0861 12.5108C20.9271 11.6631 20.9203 10.2639 20.0861 9.4368C19.2314 8.58903 17.8946 8.59593 17.0364 9.4368L16.5714 9.89171L16.1065 9.4368C15.2483 8.59593 13.9115 8.58903 13.0568 9.4368C12.2226 10.2639 12.2158 11.6631 13.0568 12.5108L16.5714 16.0536Z",
    fill: "#EF525A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_649_548)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.4286,
    y: 8.80356,
    width: 4.14286,
    height: 7.25,
    fill: "#F3858B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInHomeCareIcon);
export default __webpack_public_path__ + "static/media/In-home-care-icon.f2dac6bd41706238f80fb54e9c565f6a.svg";
export { ForwardRef as ReactComponent };